import { render, staticRenderFns } from "./Voluntario.vue?vue&type=template&id=4498b27c&scoped=true"
import script from "./Voluntario.vue?vue&type=script&lang=js"
export * from "./Voluntario.vue?vue&type=script&lang=js"
import style0 from "./Voluntario.vue?vue&type=style&index=0&id=4498b27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498b27c",
  null
  
)

export default component.exports